import React, { Component } from "react";
import LayoutBackoffice from "../../header_footer/LayoutBackoffice";
import{FormattedDate} from "react-intl";

import axios from "axios";
import PropTypes from "prop-types";

import { deleteDataonServer } from "../../../../components/utils/RequestsHelper";

import Modal from "react-modal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

Modal.setAppElement(document.getElementById("root"));

class Aviso extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      aviso: {},
      modalIsOpen: false
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  componentDidMount = () => {
    this.loadAviso();
  };

  editButtonClicked = () => {
    this.context.router.history.push(
      "/backoffice/avisos/editar/" + this.state.aviso._id
    );
  };

  deleteButtonClicked = () => {
    let promiseObj = deleteDataonServer(
      "/api/avisos/" + this.props.match.params.identifier
    );
    promiseObj
      .then((response) => {
        if (response !== undefined) {
          this.context.router.history.push("/backoffice/avisos");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  loadAviso = async () => {
    let identifier = this.props.match.params.identifier;

    let res = {};
    try {
      res = await axios.get("/api/avisos/" + identifier, {
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
        },
      });
    } catch (error) {
      console.log(error);
    }

    let aviso = res.data.aviso;
    console.log(res.data.aviso);
    this.setState({ aviso });
  };

  splitFileName = (filename) => {
    if(filename !== '' && filename !== null) {
      return filename.substring(13);
    } 
    return '';
    
  }

  render() {
    return (
      <LayoutBackoffice>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <h4>Deseja apagar o Aviso?</h4>

          <p>Se apagar, não poderá voltar atrás.</p>

          <div className="">
            <button
              onClick={this.deleteButtonClicked}
              className="backoffice-btn btn btn-outline-success"
            >
              Sim, Apagar
            </button>

            <button
              className="backoffice-btn btn btn-outline-danger"
              onClick={this.closeModal}
            >
              Cancelar
            </button>
          </div>
        </Modal>

        <div className="container backoffice-details">
          <div className="div-btn">
            <button
              type="button"
              className="backoffice-btn btn btn-outline-info"
              onClick={this.editButtonClicked}
            >
              Editar
            </button>
            <button
              type="button"
              className="backoffice-btn btn btn-outline-danger"
              onClick={this.openModal}
            >
              Apagar
            </button>
          </div>

          <div>
            <p className="labels">Título</p>
            <p className="details">{this.state.aviso.title}</p>

            <p className="labels">Descrição das listagens</p>
            <p className="details">{this.state.aviso.smallDescription}</p>

            <p className="labels">Descrição</p>
            <p
              className="details"
              dangerouslySetInnerHTML={{ __html: this.state.aviso.description }}
            ></p>

            <p className="labels">Ficheiro</p>
            {this.state.aviso.file !== null && this.state.aviso.file !== undefined && this.state.aviso.file !== '' ? (
              <p className="details">{this.splitFileName(this.state.aviso.file)}</p>
            ) : (
              <p className="details">Não tem ficheiro associado</p>
            )}

            <p className="labels">Tipo</p>
            <p className="details">{this.state.aviso.type}</p>
            
            <p className="labels">Data de criação</p>
            {this.state.aviso.date !== null && 
                
                <p className="details">
                <FormattedDate
                    value={this.state.aviso.date}
                    year="numeric"
                    month="long"
                    day="2-digit"
                />
                </p>
            }

            <p className="labels">Está Ativo?</p>
            <p className="details">{this.state.aviso.isActive ? "Sim" : "Não"}</p>
          </div>
        </div>
      </LayoutBackoffice>
    );
  }
}

export default Aviso;
